__turbopack_context__.v({
  "counter": "ScoreCounter-module__p_VqYW__counter",
  "root": "ScoreCounter-module__p_VqYW__root",
});
